// @flow
import { uniq } from '@finect/front-utils/uniq';

export const getBankProductSubtypes = (subtypes: Array<string>): Array<string> => [...uniq(subtypes)].sort();
